module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/skew-outline-button/skew-outline-button.component.scss
// module id = ./src/app/features/buttons/skew-outline-button/skew-outline-button.component.scss
// module chunks = main